import { render, staticRenderFns } from "./file-item.vue?vue&type=template&id=72a12f9f"
import script from "./file-item.vue?vue&type=script&lang=js"
export * from "./file-item.vue?vue&type=script&lang=js"
import style0 from "./file-item.vue?vue&type=style&index=0&id=72a12f9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./file-item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports